import React from 'react';

const Logo = ({ size = 40, className = '' }) => {
  return (
    <img 
      src="/logo.png" 
      alt="FINBRO Logo" 
      width={size} 
      height={size} 
      className={`rounded-lg object-cover ${className}`}
      style={{ minWidth: size, minHeight: size }}
    />
  );
};

export default Logo;
